export const BASE_DATE_FORMAT = "DD/MM/YYYY";
export const DATE_FORMAT_WITH_SEPARATOR_REVERSED = "YYYY-MM-DD";
export const LONG_DATE_FORMAT = "dddd Do MMMM YYYY";
export const DATE_FORMAT_WITH_DAY = "ddd, DD/MM/YY";
export const BASE_CURRENCY_FORMAT = "$0,0.00";
export const DATE_FORMAT_WITH_TIME = "dddd Do MMMM YYYY hh:mm A";
export const API_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS";
export const BOOLEAN_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];
export const DEFAULT_CURRENCY = "GBP";
